import React from 'react';
import { Box } from '@mui/material';

import { Page4Flow, Page4Window } from './types';
import { wsrColors, wsrMonoFont } from './wsrTokens';

interface FlowCardProps {
  flow: Page4Flow;
  window: Page4Window;
}

interface Stage {
  label: string;
  value: number;
  color: string;
}

const FlowCard: React.FC<FlowCardProps> = ({ flow, window }) => {
  const stages: Stage[] = [
    { label: 'Raised', value: flow.raised, color: wsrColors.blue },
    { label: 'Resolved', value: flow.resolved, color: wsrColors.green },
    { label: 'Outstanding', value: flow.outstanding, color: wsrColors.amber },
  ];

  return (
    <Box
      sx={{
        background: '#fff',
        border: `1px solid ${wsrColors.slate200}`,
        borderRadius: '12px',
        padding: '20px',
      }}
    >
      <Box sx={{ fontSize: 15, fontWeight: 600, marginBottom: '14px' }}>Weekly Flow</Box>
      <Box sx={{ display: 'flex', alignItems: 'stretch', gap: '8px' }}>
        {stages.map((stage, i) => (
          <React.Fragment key={stage.label}>
            <Box
              sx={{
                flex: 1,
                padding: '16px 14px',
                borderRadius: '10px',
                background: `color-mix(in oklab, ${stage.color} 8%, white)`,
                border: `1px solid color-mix(in oklab, ${stage.color} 20%, white)`,
              }}
            >
              <Box
                sx={{
                  fontSize: 11,
                  color: wsrColors.slate500,
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '.06em',
                }}
              >
                {stage.label}
              </Box>
              <Box sx={{ marginTop: '4px', fontSize: 26, fontWeight: 700, color: stage.color }}>
                {stage.value}
              </Box>
            </Box>
            {i < stages.length - 1 && (
              <Box
                sx={{
                  display: 'grid',
                  placeItems: 'center',
                  color: wsrColors.slate300,
                  fontSize: 20,
                }}
              >
                →
              </Box>
            )}
          </React.Fragment>
        ))}
      </Box>
      <Box sx={{ marginTop: '14px', fontSize: 12, color: wsrColors.slate500 }}>
        Window:{' '}
        <Box component="span" sx={{ fontFamily: wsrMonoFont, color: wsrColors.slate700 }}>
          {window.start} → {window.end}
        </Box>
        <Box component="span" sx={{ marginLeft: '6px', color: wsrColors.slate400 }}>
          (end exclusive)
        </Box>
      </Box>
    </Box>
  );
};

export default FlowCard;
